import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd, { SITE_ORIGIN, SITE_FAVICON, SITE_NAME } from '@/components/feature/JsonLd';
import Hero from './components/Hero';
import Categories from './components/Categories';
import About from './components/About';
import Popular from './components/Popular';
import Comparison from './components/Comparison';
import Safety from './components/Safety';
import Articles from './components/Articles';
import FinalCta from './components/FinalCta';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: `${SITE_ORIGIN}/`,
  inLanguage: 'en',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: `${SITE_ORIGIN}/`,
  logo: SITE_FAVICON,
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <About />
        <Popular />
        <Comparison />
        <Safety />
        <Articles />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}